<template>
  <!-- begin::Body -->
  <div class="m-grid__item m-grid__item--fluid m-wrapper">

    <!-- BEGIN: Subheader -->
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title">{{$t('support.noaccess.title')}}</h3>
        </div>
      </div>
    </div>
    <!-- END: Subheader -->

    <div class="m-content">

      <div
        class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-danger alert-dismissible fade show"
        role="alert">
        <div class="m-alert__icon">
          <i class="flaticon-exclamation-1"></i>
          <span></span>
        </div>
        <div class="m-alert__text">
          {{$t('support.noaccess.info')}}
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-8 col-lg-7 col-xl-8">
          <div class="m-portlet m-portlet--rounded noContractedServices">
            <formSupport
              :contact="contact"
              :sendContactForm="sendContactForm"></formSupport>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-4 col-lg-5 col-xl-4">
          <div class="m-portlet m-portlet--rounded">
            <infoSupport></infoSupport>
          </div>
        </div>
      </div>
    </div>


  </div>
  <!-- end:: Body -->
</template>

<script>

  import AppHeader from '@/components/dashboard/common/Header'
  import AppFooter from '@/components/dashboard/common/Footer'
  import LeftMenu from '@/components/dashboard/common/menus/LeftMenu'

  import functions from "@/plugins/functions"

  import formSupport from '@/components/dashboard/support/Form'
  import infoSupport from '@/components/dashboard/support/Info'

  export default {
    components: {
      AppFooter,
      AppHeader,
      LeftMenu,
      formSupport,
      infoSupport
    },
    methods: {
      async sendContactForm() {

        if (this.contact.body === null || this.contact.subject === null) {
          swal({
            title: this.$t('error.MissingFields'),
            text: this.$t('error.PleaseFillUpAllFields'),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          return;
        }

        let params = {
          'subject': this.contact.subject,
          'body': this.contact.body
        }

        let response = await clientapi.post('/contact', params)

        if (response.status === 200) {
          swal({
            title: this.$t('success.formSubmitedOK'),
            text: response.data.message,
            type: "success",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
          this.contact.body = ""
          this.contact.subject = ""
        } else {
          let errorCode = response.data.code
          swal({
            title: this.$t('error.AnErrorOccurred'),
            text: this.$t('error.server.'+errorCode),
            type: "error",
            confirmButtonClass: "btn btn-brand m-btn m-btn--wide",
            onBeforeOpen: () => { functions.onBeforeOpenSwal() }
          })
        }
      }
    },
    data() {
      return {
        contact: {
          subject: this.$t('support.noaccess.form.subject'),
          body: null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/services/Directory.vue